import CustomField from './CustomField'
import Flow from './Flow'
import FlowStep from './FlowStep'
import RegisterAdd from './RegisterAdd'
import JobQrCode from './JobQrCode'
import WorkShop from './WorkShop'
import Employee from './Employee'
import BookingField from './BookingField'
import BookingLink from './BookingLink'
import Branch from './Branch'
import Company from './Company'
import BookingList from './BookingList'
import JobList from './JobList'
import Qrcodereader from './Qrcodereader.vue'
import PaymentType from './PaymentType.vue'
import Rating from './Rating'
import RatingEmp from './RatingEmp'
import CalendarBooking from './CalendarBooking'
import BoardControl from './BoardControl'
import BoardControlEmp from './BoardControlEmp'
import SettingLineGroup from './SettingLineGroup'
import BookingMobile from './BookingMobile'
import BoardControlM from './BoardControlM'
import UpdateNotify from './UpdateNotify'
import SettingLineNotify from './SettingLineNotify'
import BookingListOnsite from './BookingListOnsite'
import BoardControlBeauty from './BoardControlBeauty'
import BoardControlBeautyFilter from './BoardControlBeautyFilter'
import BookingListBeauty from './BookingListBeauty'
import SettingTag from './SettingTag'
import Showbooking from './Showbooking'
import BookingMobileConfirmJob from './BookingMobileConfirmJob'
import ServiceType from './ServiceType'
import BookingMobileEmp from './BookingMobileEmp'
import NoticeManagement from './NoticeManagement'
import CheckBookingEmpList from './CheckBookingEmpList'
import BookingListBeautyEmp from './BookingListBeautyEmp'
import ManageLink from './ManageLink'
import TableCheckQueue from './TableCheckQueue'
import BookingListQueue from './BookingListQueue'
import BookingListQueueMonitoring from './BookingListQueueMonitoring'
import WorkShopComponent from './WorkShopComponent'
import ChatHistory from './ChatHistory'
import BookingListQueueByUser from './BookingListQueueByUser'
import BookingListQueueByUserOhrich from './BookingListQueueByUserOhrich'
import BookingListQueueByStoreFront from './BookingListQueueByStoreFront'
import BookingListQueueMonitoringVideo from './BookingListQueueMonitoringVideo'
import BookingListQueueMonitoringVideoNew from './BookingListQueueMonitoringVideoNew'
import BookingWalkinEmp from './BookingWalkinEmp'
import BookingWalkin from './BookingWalkin.vue'
import CheckBookingList from './CheckBookingList.vue'
import AdminStampStep from './AdminStampStep.vue'
import BookingByUserEmp from './BookingByUserEmp.vue'
import BookingListQueueMonitoringVideoOhrich from './BookingListQueueMonitoringVideoOhrich.vue'
import BookingListQueueMonitoringVideoOhrichV1 from './BookingListQueueMonitoringVideoOhrichV1.vue'
import BookingListQueueTestPlaySound from './BookingListQueueTestPlaySound.vue'
import BookingListQueueByUserEventCat from './BookingListQueueByUserEventCat'
import BookingListQueueMonitoringVideoEventCat from './BookingListQueueMonitoringVideoEventCat'
import BookingListQueueMonitoringVideoEvent from './BookingListQueueMonitoringVideoEvent.vue'
import BookingListQueueByUserEvent from './BookingListQueueByUserEvent.vue'
import BookingListQueueByUserNoppakao from './BookingListQueueByUserNoppakao.vue'
// import BookingListBeautyEmpTestRedis from './BookingListBeautyEmpTestRedis.vue'
import BookingListQueuePanel from './BookingListQueuePanel'
import BookingListQueueMonitoringVideoNewCar from './BookingListQueueMonitoringVideoNewCar.vue'
import BookingListQueueMonitoringVideoPharaThonburi from './BookingListQueueMonitoringVideoPharaThonburi.vue'
import BookingJob from './BookingJob'
import BookingListQueueMonitoringVideoNoppakao from './BookingListQueueMonitoringVideoNoppakao'
import BookingListQueueForwarding from './BookingListQueueForwarding'
import BookingForwardQueue from './BookingForwardQueue'
import ManageCode from './ManageCode'
import BookingListQueueKrungthaiWesternHospital from './BookingListQueueKrungthaiWesternHospital'
import BookingListQueueCentralPattana from './BookingListQueueCentralPattana'
import BookingListQueueWonderfruitTaxi from './BookingListQueueWonderfruitTaxi'
import ManageDataTaxi from './Manage_Data_Taxi'

export default {
  BookingByUserEmp,
  // BookingListBeautyEmpTestRedis,
  AdminStampStep,
  ChatHistory,
  WorkShopComponent,
  CustomField,
  ServiceType,
  NoticeManagement,
  Flow,
  FlowStep,
  RegisterAdd,
  JobQrCode,
  WorkShop,
  Employee,
  BookingField,
  BookingLink,
  Branch,
  Company,
  BookingList,
  JobList,
  Qrcodereader,
  PaymentType,
  Rating,
  CalendarBooking,
  BoardControl,
  BoardControlEmp,
  SettingLineGroup,
  BookingMobile,
  BoardControlM,
  UpdateNotify,
  SettingLineNotify,
  BookingListOnsite,
  BoardControlBeauty,
  BoardControlBeautyFilter,
  BookingListBeauty,
  SettingTag,
  Showbooking,
  BookingMobileConfirmJob,
  BookingMobileEmp,
  CheckBookingEmpList,
  BookingListBeautyEmp,
  ManageLink,
  TableCheckQueue,
  BookingListQueue,
  BookingListQueueMonitoring,
  BookingListQueueByUser,
  BookingListQueueByUserOhrich,
  BookingListQueueMonitoringVideo,
  BookingListQueueMonitoringVideoNew,
  BookingWalkinEmp,
  BookingWalkin,
  CheckBookingList,
  BookingListQueueMonitoringVideoOhrich,
  BookingListQueueMonitoringVideoOhrichV1,
  BookingListQueueTestPlaySound,
  BookingListQueueByUserEventCat,
  BookingListQueueMonitoringVideoEventCat,
  BookingListQueueMonitoringVideoEvent,
  BookingListQueueByUserEvent,
  BookingListQueuePanel,
  BookingListQueueMonitoringVideoNewCar,
  BookingJob,
  RatingEmp,
  BookingListQueueByUserNoppakao,
  BookingListQueueMonitoringVideoNoppakao,
  BookingListQueueMonitoringVideoPharaThonburi,
  BookingListQueueByStoreFront,
  BookingListQueueForwarding,
  BookingForwardQueue,
  ManageCode,
  BookingListQueueKrungthaiWesternHospital,
  BookingListQueueCentralPattana,
  BookingListQueueWonderfruitTaxi,
  ManageDataTaxi
}



// WEBPACK FOOTER //
// ./src/components/Master/index.js